<script setup>
import {useModalsStore} from '@/stores/modals'
import {useAppStore} from '@/stores/appStore'

const modalsStore = useModalsStore()
const appStore = useAppStore()

const onClick = () => {
    modalsStore.show({
        componentName: 'ZendeskModal'
    })

    appStore.showSupport = false
}
</script>

<template>
    <button class="btn btn-light btn-sm" @click="onClick">
        Raise a ticket
    </button>
</template>